const copyToClipboard = async (text: string) => {
  const writeTextIntoClipboard = await navigator.clipboard.writeText(text);
  return writeTextIntoClipboard;
};

export default copyToClipboard;
